import React from 'react'
import './Games.css'
import { useNavigate } from 'react-router-dom'

const Games = () => {
  const navigate=useNavigate()
  return (
    <div className='GamesContainer'>
      <div className="Intro">
        <h1>🔱 Game Center : Combinatorics Problem Simulator</h1>
         <p><b>Purpose : </b>This section aims for clarifying a combinatorics problem so that it would be easier for the student to come up with a solution. That's why you are required to write a full solution to the problem. 
         </p>
      </div>
      <div className="GamesContainer-Content">
        <div className="GameConatiner">
        <button onClick={()=>navigate('/Games/Confucius')}>
           🥡 IMO 2026 Problem 1 : Confucius 
          </button>
        </div>
        <div className="GameConatiner">
        <button onClick={()=>navigate('/Games/CardGame')}>
           🃏 OFM 2026 Problem 2 : Card Games
          </button>
        </div>
        <div className='GameConatiner'>
        
          <button onClick={()=>navigate('/Games/Chess')}>
           ♟️Chess Related Games 
          </button>
        </div>
        <div className='GameConatiner'>
          <button onClick={()=>navigate('/Games/Turbo')}>
           🐌 IMO 2024 Problem 5 : Turbo
          </button>
        </div>
      </div>
   
    </div>
  )
}

export default Games
